import { deepClone, getDecryptLocalStorage } from "../../utils/global_functions";
import { SCRIP_SEARCH, SET_ARR_SCRIPS_TO_BE_ADDED } from "../actionTypes";
import { getAlerts } from '../../redux/actions/alerts';
import { event } from '../../redux/actions/events';
import { getIPOs } from '../../redux/actions/Ipo';
import { EXCHANGE_NAME_API, LOCAL_STORAGE_KEYS } from "../../utils/global_variables";
import { convertScripResponseWatchlistGrid } from "../../utils/global_functions";
import dayjs from 'dayjs';
import {
    _getSearchScripsEquity, _getSearchAllScrips, _getSearchPages, _getSearchScrips, _getSearchScripsFutures,
    _getSearchScripsOptions, _getFilteredRecommendationScrips, _getFilteredAlertScrips, _getFilteredEventScrips,
    _getFilteredIPOScrips, _getFilteredNewsScrips
} from "../../controllers";
import moment from "moment"; //BT-114442 : Option tab functionality : ManasaB : 11/08/2023
import { recommendation } from '../../redux/actions/recommendation';
import { _getSearchScripsMutualFunds } from "../../controllers/globalSearch";
import { saveDistinctDates, updateArrFutOptionScrips, updateArrOnlyOptionChainDataFromGlobalSearchAction } from "./optionChain";//ManasaB : 30/11/2023 : BT-115296 Calculator Bug Fixing 
import { getDistinctExpiry } from "../../apis";
const nPage = 1;
const nItems = -1;

export const updateIsLoading = (payload) => {
    return { type: SCRIP_SEARCH.IS_LOADING, payload };
};
const ipoPayload = {
    offerName: "", offerType: "IPO"
};
export const getSearchAllScrips = (sSearchText, mktAllowed, pageNo, totalNoOfElements) => async (dispatch, getState) => {
    dispatch(updateIsLoading(true));
    const { data: arrSearchAllScrips = [] } = deepClone(getState().globalSearch.searchAllScrips);
    const objResponse = await _getSearchAllScrips(sSearchText, mktAllowed, pageNo, totalNoOfElements);
    if (objResponse.status) {
        if (objResponse?.data?.arrSearchData && objResponse?.data?.arrSearchData.length > 0) {
            if (arrSearchAllScrips?.length > 0) {
                dispatch(searchSuccess({ data: [...arrSearchAllScrips, ...objResponse?.data?.arrSearchData], count: objResponse?.data?.objScripResp?.data?.result.hits.total.value }));
            } else {
                dispatch(searchSuccess({ data: objResponse?.data?.arrSearchData, count: objResponse?.data?.objScripResp?.data?.result.hits.total.value }));
            }
            if (objResponse?.data?.expiryDates?.length > 0) {
                dispatch(saveDistinctDates(objResponse?.data?.expiryDates));
            }
            dispatch(updateIsLoading(false));
            return Promise?.resolve(objResponse?.data?.objScripResp);//BT-96728 - Global Search Feature : ManasaB : 22/07/2023 
        } else {
            dispatch(updateIsLoading(false));
        }
    }
    else {
        dispatch(updateIsLoading(false));
        dispatch(searchFailure({ data: [], count: 0 }));
    }
};


export const searchSuccess = (payload) => {
    return { type: SCRIP_SEARCH.GET_SEARCH_ALL_SCRIPS_SUCCESS, payload };
};

export const searchFailure = (payload) => {
    return { type: SCRIP_SEARCH.GET_SEARCH_ALL_SCRIPS_FAILURE, payload };
};

export const getDistictExpiryGlobal=(sSearchText,mktAllowed)=> async(dispatch,getState)=>{
    try{
        let nOptLength = 0;
        let objLoginSession = JSON.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION));
        const objOPResp = await getDistinctExpiry(sSearchText, objLoginSession?.nExchangesViewAllowed ? objLoginSession.nExchangesViewAllowed : mktAllowed);
        const arrOptSearchData = objOPResp.data?.result?.aggregations?.optsym?.buckets;
        const arrOptionChainDataGlobalSearch = objOPResp.data?.result?.hits.hits;
        // const nOptListDataCount = objOPResp?.data?.result?.hits?.total?.value;
        arrOptSearchData?.forEach((eachOptData) => {
            let dates = [];
            nOptLength = nOptLength + eachOptData.optexp.buckets.length; //Hiral Mam suggested options tab length should be total no of expiries : ManasaB : 22/08/2023
            eachOptData.optexp.buckets.forEach(eachDate => {
                dates.push(new Date(moment(eachDate.key, "DDMMMYYYY").format("YYYY-MM-DD")));
            });
            eachOptData.dates = dates;
        });
        arrOptSearchData?.forEach((eachOptData) => {
            let maxDate = new Date(Math.max(...eachOptData.dates));
            eachOptData.maxDate = moment(maxDate, "YYYY-MM-DD").format("MMMYY");
            delete eachOptData["dates"];
        });
        if (arrOptSearchData && arrOptSearchData.length > 0) {
            dispatch(searchOptionsSuccess({ data: arrOptSearchData, count: nOptLength }));//Hiral Mam suggested options tab length should be total no of expiries : ManasaB : 22/08/2023
        }
        if (arrOptionChainDataGlobalSearch?.length > 0) {
            dispatch(updateArrOnlyOptionChainDataFromGlobalSearchAction(arrOptionChainDataGlobalSearch));
        }
    }catch(e){
        console.log(e)
        dispatch(searchOptionsFailure({ data: [], count: 0 }))
    }
};

export const getSearchScrips = (sSearchText, mktAllowed, pageNo, totalNoOfElements, isDefaultAllTab, isSpanMargin) => async (dispatch, getState) => {
    try {
        let nOptLength = 0;
        let arrRecommendationScrips = [];
        let arrEventScrips = [];
        let arrAlertScrips = [];
        let arrNewsScrips = [];
        let arrIPOScrips = [];
        dispatch(searchFailure({ data: [], count: 0 }));
        dispatch(searchEquityFailure({ data: [], count: 0 }));
        dispatch(searchFuturesFailure({ data: [], count: 0 }));
        dispatch(searchOptionsFailure({ data: [], count: 0 }));
        dispatch(updateSearchRecommendationsFailure({ data: [], count: 0 }));
        dispatch(updateSearchAlertsFailure({ data: [], count: 0 }));
        dispatch(updateSearchNewsFailure({ data: [], count: 0 }));
        dispatch(updateSearchIPOFailure({ data: [], count: 0 }));
        dispatch(updateSearchEventsFailure({ data: [], count: 0 }));
        dispatch(updateIsLoading(true));
        dispatch(updateSearchScripDataStatusFailure({ status: true, strNoDataMessage: '' }));
        const objLoginSession = getState().auth.objLoginSession;
        const allowedNewsCat = objLoginSession?.data?.others?.newsCategories;
        const arrRecommendationSearchScrips = deepClone(getState().recommendation.recommendations);
        const arrEvents = deepClone(getState().events.events);

        const arrNews = deepClone(getState().news?.arrHotPursuitData);
        const arrIPO = deepClone(getState().ipo.ongoingIpo);
        const arrAlerts = deepClone(getState().alerts?.arrAlerts);
        const objScripAllResp = await _getSearchAllScrips(sSearchText, objLoginSession?.nExchangesViewAllowed ? objLoginSession.nExchangesViewAllowed : mktAllowed, pageNo, totalNoOfElements);
        const arrSearchData = objScripAllResp.data.arrSearchData;
        const arrAllCount = objScripAllResp.data.objScripResp.data?.result.hits.total.value;
        if (arrSearchData && arrSearchData.length > 0) {
            dispatch(searchSuccess({ data: arrSearchData, count: arrAllCount }));
            dispatch(updateIsLoading(false));
        }
        const arrAllPages = deepClone(getState().globalSearch.arrTotalPages);
        const objResp = await _getSearchScrips(sSearchText, mktAllowed, pageNo, totalNoOfElements, isDefaultAllTab, arrAllPages, isSpanMargin);
        if(objResp?.status){
            const arrOptionTabsearchData = (isDefaultAllTab || isSpanMargin) ? objResp.data.arrOptSearchListingData : objResp.data.arrOptSearchData;
            const nOptiondataLength = (isDefaultAllTab || isSpanMargin) ? objResp.data.nOptListDataCount : nOptLength;
            if (objResp?.data?.arrEqSearchData && objResp?.data?.arrEqSearchData.length > 0) {
                dispatch(searchEquitySuccess({ data: objResp?.data?.arrEqSearchData, count: objResp?.data?.objEqResp?.data?.result.hits.total.value }));
            }
            else {
                dispatch(searchEquityFailure({ data: [], count: 0 }));
            }
            if (objResp?.data?.arrFuSearchData && objResp?.data?.arrFuSearchData.length > 0) {
                dispatch(searchFuturesSuccess({ data: objResp?.data?.arrFuSearchData, count: objResp?.data?.objFUResp.data.result.hits.total.value }));
                dispatch(updateArrFutOptionScrips(objResp?.data?.arrFuSearchData));
            }
            else {
                dispatch(searchFuturesFailure({ data: [], count: 0 }));
            }
            if (objResp.data.arrOptionChainDataGlobalSearch?.length > 0) {
                dispatch(updateArrOnlyOptionChainDataFromGlobalSearchAction(objResp.data.arrOptionChainDataGlobalSearch));
            }
            if (arrOptionTabsearchData && arrOptionTabsearchData.length > 0) {
                dispatch(searchOptionsSuccess({ data: arrOptionTabsearchData, count: nOptiondataLength }));//Hiral Mam suggested options tab length should be total no of expiries : ManasaB : 22/08/2023
            }
            const arrSearchPagesData = objResp?.data?.arrPagesData;
            if (arrSearchPagesData?.length > 0) {
                dispatch(updateSearchPages({ data: arrSearchPagesData, count: arrSearchPagesData?.length }));

            }
            else {
                dispatch(updateSearchPages({ data: [], count: 0 }));
            }
            if (objResp?.data?.arrEqSearchData.length > 0 || objResp?.data?.arrFuSearchData.length > 0 || objResp?.data?.arrOptSearchData.length > 0 ||
                arrRecommendationScrips?.length > 0 || arrAlertScrips?.length > 0 || arrNewsScrips?.length > 0 ||
                arrIPOScrips?.length > 0 || arrEventScrips?.length > 0 || arrSearchPagesData?.length > 0
                || arrOptionTabsearchData?.length > 0 || arrSearchData?.length > 0
            ) {
                dispatch(updateSearchScripDataStatusSuccess({ status: true, strNoDataMessage: '' }));
            }
            else {
                dispatch(updateSearchScripDataStatusFailure({ status: false, strNoDataMessage: 'No data. Try adujusting your search or filter to find what you are looking for' }));
            }
            if (!isDefaultAllTab && !isSpanMargin) {
                dispatch(getDistictExpiryGlobal(sSearchText,-1));
            }
        }
        //RECOMMENDATIONS
        const arrScripInfo = getState().scripInfo?.scripInfo;
        const recommendationsWithScripInfo = [];
        if (arrRecommendationSearchScrips?.length > 0) {
            if (arrScripInfo?.length > 0) {
                arrRecommendationSearchScrips.forEach((each) => {
                    const matchedScrip = arrScripInfo.find((eachScrip) => (eachScrip?.id === `${each?.nMarketSegmentId + '-' + each?.nToken}`));
                    if (matchedScrip && Object.keys(matchedScrip)?.length > 0) {
                        recommendationsWithScripInfo.push({ ...each, scripInfo: convertScripResponseWatchlistGrid([matchedScrip])[0] });
                    } else { }
                });
            } else { }
        } else { }
        if (recommendationsWithScripInfo?.length > 0) {
            const objRecoResp = _getFilteredRecommendationScrips(sSearchText, recommendationsWithScripInfo);
            if (objRecoResp.status) {
                arrRecommendationScrips = objRecoResp.data.arrRecoScrips;
                dispatch(updateSearchRecommendationsSuccess({ data: arrRecommendationScrips, count: arrRecommendationScrips?.length }));
            }
        }
        else {
            const recommendations = await dispatch(recommendation(allowedNewsCat, nPage, nItems));
            if (recommendations?.length > 0) {
                const objRecoResp = _getFilteredRecommendationScrips(sSearchText, recommendations);
                if (objRecoResp.status) {
                    arrRecommendationScrips = objRecoResp.data.arrRecoScrips;
                    dispatch(updateSearchRecommendationsSuccess({ data: arrRecommendationScrips, count: arrRecommendationScrips?.length }));
                }
            }
            else {
                dispatch(updateSearchRecommendationsFailure({ data: [], count: 0 }));
            }
        }

        //ALERTS
        if (arrAlerts?.length > 0) {
            const objAlertResp = _getFilteredAlertScrips(sSearchText, arrAlerts);
            if (objAlertResp.status) {
                arrAlertScrips = objAlertResp.data.arrSearchAlertScrips;
            }

        }
        else {
            //alerts api call
            const arrAlertSearchScrips = await dispatch(getAlerts(objLoginSession?.data?.user_id));
            if (arrAlertSearchScrips?.length > 0) {
                const objAlertResp = _getFilteredAlertScrips(sSearchText, arrAlertSearchScrips);
                if (objAlertResp.status) {
                    arrAlertScrips = objAlertResp.data.arrSearchAlertScrips;
                }
            }
            else {
                dispatch(updateSearchAlertsFailure({ data: [], count: 0 }));
            }


        }

        //NEWS

        if (arrNews?.length > 0) {
            const objNewsResp = _getFilteredNewsScrips(sSearchText, arrNews);
            if (objNewsResp.status) {
                arrNewsScrips = objNewsResp.data.arrSearchNewsScrips;
                dispatch(updateSearchNewsSuccess({ data: arrNewsScrips, count: arrNewsScrips?.length }));
            }

        }
        else {
            dispatch(updateSearchNewsFailure({ data: [], count: 0 }));
        }

        //IPO

        if (arrIPO?.length > 0) {
            const objIPOResp = _getFilteredIPOScrips(sSearchText, arrIPO);
            if (objIPOResp.status) {
                arrIPOScrips = objIPOResp.data.arrSearchIPOScrips;
            }

        }
        else {
            //ipo api call
            const ongoingIpo = await dispatch(getIPOs(ipoPayload));
            if (ongoingIpo?.length > 0) {
                const objIPOResp = _getFilteredIPOScrips(sSearchText, ongoingIpo);
                if (objIPOResp.status) {
                    arrIPOScrips = objIPOResp.data.arrSearchIPOScrips;
                }
            }
            else {
                dispatch(updateSearchIPOFailure({ data: [], count: 0 }));
            }

        }

        //EVENTS
        if (arrEvents?.length > 0) {
            const objEventResp = _getFilteredEventScrips(sSearchText, arrEvents);
            if (objEventResp.status) {
                arrEventScrips = objEventResp.data.arrSearchEventScrips;
            }
        }
        else {
            const eventEndDate = dayjs().endOf('month').format('DD-MMM-YYYY');
            const exhcangeType = EXCHANGE_NAME_API.NSE_EQ_API;
            const eventStartDate = dayjs().startOf('month').format('DD-MMM-YYYY');
            const arrScripEvents = await dispatch(event(eventStartDate, eventEndDate, exhcangeType, 1));
            if (arrScripEvents?.length > 0) {
                const objEventResp = _getFilteredEventScrips(sSearchText, arrScripEvents);
                if (objEventResp.status) {
                    arrEventScrips = objEventResp.data.arrSearchEventScrips;
                }
            }
            else {
                dispatch(updateSearchEventsFailure({ data: [], count: 0 }));
            }

        }
        
        if (objResp?.status) {
            //BT-114442 : Option tab functionality : ManasaB : 11/08/2023 : To get max date - Start
            // if (!isDefaultAllTab && !isSpanMargin) {
            //     objResp.data?.arrOptSearchData?.forEach((eachOptData) => {
            //         let dates = [];
            //         nOptLength = nOptLength + eachOptData.optexp.buckets.length; //Hiral Mam suggested options tab length should be total no of expiries : ManasaB : 22/08/2023
            //         eachOptData.optexp.buckets.forEach(eachDate => {
            //             dates.push(new Date(moment(eachDate.key, "DDMMMYYYY").format("YYYY-MM-DD")));
            //         });
            //         eachOptData.dates = dates;
            //     });
            //     objResp.data?.arrOptSearchData?.forEach((eachOptData) => {
            //         let maxDate = new Date(Math.max(...eachOptData.dates));
            //         eachOptData.maxDate = moment(maxDate, "YYYY-MM-DD").format("MMMYY");
            //         delete eachOptData["dates"];
            //     });
            // }
            //BT-114442 : Option tab functionality : ManasaB : 11/08/2023 - End
            
            if (arrRecommendationScrips && arrRecommendationScrips.length > 0) {
                dispatch(updateSearchRecommendationsSuccess({ data: arrRecommendationScrips, count: arrRecommendationScrips.length }));
            }
            else {
                dispatch(updateSearchRecommendationsFailure({ data: [], count: 0 }));
            }
            if (arrAlertScrips && arrAlertScrips.length > 0) {
                dispatch(updateSearchAlertsSuccess({ data: arrAlertScrips, count: arrAlertScrips.length }));
            }
            else {
                dispatch(updateSearchAlertsFailure({ data: [], count: 0 }));
            }
            if (arrNewsScrips && arrNewsScrips.length > 0) {
                dispatch(updateSearchNewsSuccess({ data: arrNewsScrips, count: arrNewsScrips.length }));
            }
            else {
                dispatch(updateSearchNewsFailure({ data: [], count: 0 }));
            }
            if (arrIPOScrips && arrIPOScrips.length > 0) {
                dispatch(updateSearchIPOSuccess({ data: arrIPOScrips, count: arrIPOScrips.length }));
            }
            else {
                dispatch(updateSearchIPOFailure({ data: [], count: 0 }));
            }
            if (arrEventScrips && arrEventScrips.length > 0) {
                dispatch(updateSearchEventsSuccess({ data: arrEventScrips, count: arrEventScrips.length }));
            }
            else {
                dispatch(updateSearchEventsFailure({ data: [], count: 0 }));
            }
        } else {
            dispatch(searchEquityFailure({ data: [], count: 0 }));
            dispatch(searchFailure({ data: [], count: 0 }));
            dispatch(searchFuturesFailure({ data: [], count: 0 }));
            dispatch(searchOptionsFailure({ data: [], count: 0 }));
            dispatch(updateSearchRecommendationsFailure({ data: [], count: 0 }));
            dispatch(updateSearchAlertsFailure({ data: [], count: 0 }));
            dispatch(updateSearchNewsFailure({ data: [], count: 0 }));
            dispatch(updateSearchIPOFailure({ data: [], count: 0 }));
            dispatch(updateSearchEventsFailure({ data: [], count: 0 }));
        }
        dispatch(updateIsLoading(false));
    } catch (e) {
        console.error(e);
        dispatch(updateIsLoading(false));
        dispatch(searchEquityFailure({ data: [], count: 0 }));
        dispatch(searchFailure({ data: [], count: 0 }));
        dispatch(searchFuturesFailure({ data: [], count: 0 }));
        dispatch(searchOptionsFailure({ data: [], count: 0 }));
        dispatch(updateSearchRecommendationsFailure({ data: [], count: 0 }));
        dispatch(updateSearchAlertsFailure({ data: [], count: 0 }));
        dispatch(updateSearchNewsFailure({ data: [], count: 0 }));
        dispatch(updateSearchIPOFailure({ data: [], count: 0 }));
        dispatch(updateSearchEventsFailure({ data: [], count: 0 }));
        dispatch(updateSearchScripDataStatusFailure({ status: true, strNoDataMessage: '' }));
    }
};

export const getSearchScripsEquity = (sSearchText, mktAllowed, pageNo, totalNoOfElements) => async (dispatch, getState) => {
    // dispatch(searchEquityFailure({ data: [], count: 0 }));
    dispatch(updateIsLoading(true));
    dispatch(updateSearchScripDataStatusFailure({ status: true, strNoDataMessage: '' }));//ManasaB : 23-09-2024 : Ordercart Infinite loop issue 
    const { data: arrSearchEqScrips = [] } = deepClone(getState().globalSearch.searchEqScrips);
    const objResp = await _getSearchScripsEquity(sSearchText, mktAllowed, pageNo, totalNoOfElements);
    if (objResp?.status) {
        if (objResp?.data?.arrSearchData && objResp?.data?.arrSearchData.length > 0) {
            dispatch(searchEquitySuccess({ data: [...arrSearchEqScrips, ...objResp?.data?.arrSearchData], count: objResp?.data?.objEqResp.data.result.hits.total.value }));
            dispatch(updateIsLoading(false));
        }
        else {
            dispatch(updateSearchScripDataStatusFailure({ status: false, strNoDataMessage: 'No data. Try adujusting your search or filter to find what you are looking for' }));//ManasaB : 23-09-2024 : Ordercart Infinite loop issue
            dispatch(updateIsLoading(false));
            dispatch(searchEquityFailure({ data: [], count: 0 }));
        }
        return Promise?.resolve(objResp?.data?.objResp);//BT-114263 : Removing "All" tab and Adding count in search tabs : ManasaB : 24/07/2023       
    } else {
        dispatch(updateIsLoading(false));
        dispatch(searchEquityFailure({ data: [], count: 0 }));
    }
};
export const updateSearchScripDataStatusSuccess = (payload) => {
    return { type: SCRIP_SEARCH.UPDATE_SEARCH_SCRIP_DATA_STATUS_SUCCESS, payload };
};
export const updateSearchScripDataStatusFailure = (payload) => {
    return { type: SCRIP_SEARCH.UPDATE_SEARCH_SCRIP_DATA_STATUS_FAILURE, payload };
};

// {/* BT-118877 : Functional Implementation - Global Search : Vinit R : 09/10/2023 - Start */ }
export const updateSearchMFScripDataStatusSuccess = (payload) => {
    return { type: SCRIP_SEARCH.UPDATE_SEARCH_MF_SCRIP_DATA_STATUS_SUCCESS, payload };
};
export const updateSearchMFScripDataStatusFailure = (payload) => {
    return { type: SCRIP_SEARCH.UPDATE_SEARCH_MF_SCRIP_DATA_STATUS_SUCCESS, payload };
};
// {/* BT-118877 : Functional Implementation - Global Search : Vinit R : 09/10/2023 - End */ }

export const searchEquitySuccess = (payload) => {
    return { type: SCRIP_SEARCH.GET_SEARCH_EQ_SCRIPS_SUCCESS, payload };
};

export const searchEquityFailure = (payload) => {
    return { type: SCRIP_SEARCH.GET_SEARCH_EQ_SCRIPS_FAILURE, payload };
};

// {/* BT-118877 : Functional Implementation - Global Search : Vinit R : 09/10/2023 - Start */ }
export const getSearchScripsMutualFunds = (sSearchText, mktAllowed, pageNo, totalNoOfElements) => async (dispatch, getState) => {
    dispatch(updateIsLoading(true));
    const { data: arrSearchMutualFundsScrips = [] } = deepClone(getState().globalSearch.searchMFScrips);
    const objResp = await _getSearchScripsMutualFunds(sSearchText, mktAllowed, pageNo, totalNoOfElements);

    if (objResp?.status) {
        if (objResp?.data?.objMFResp && objResp?.data?.objMFResp.length > 0) {
            dispatch(searchMutulFundsSuccess({ data: [...arrSearchMutualFundsScrips, ...objResp.data.objMFResp], count: objResp.data.metadata.total_count }));
            dispatch(updateIsLoading(false));
        }
        else {
            dispatch(updateIsLoading(false));
            dispatch(searchMutualFundsFailure({ data: [], count: 0 }));
        }

        if (objResp?.data?.objMFResp && objResp?.data?.objMFResp.length > 0) {
            dispatch(updateSearchMFScripDataStatusSuccess({ status: true, strNoDataMessage: '' }));
        }
        else {
            dispatch(updateSearchMFScripDataStatusFailure({ status: false, strNoDataMessage: 'No matches found. Try adjusting your search or filter to find what you are looking for' }));
        }

        return Promise?.resolve(objResp?.data?.objMFResp);
    } else {
        dispatch(updateIsLoading(false));
        dispatch(searchMutualFundsFailure({ data: [], count: 0 }));
    }
};

export const searchMutulFundsSuccess = (payload) => {
    return { type: SCRIP_SEARCH.GET_SEARCH_MF_SCRIPS_SUCCESS, payload };
};

export const searchMutualFundsFailure = (payload) => {
    return { type: SCRIP_SEARCH.GET_SEARCH_MF_SCRIPS_FAILURE, payload };
};
// {/* BT-118877 : Functional Implementation - Global Search : Vinit R : 09/10/2023 - End */ }

export const getSearchScripsFutures = (sSearchText, mktAllowed, pageNo, totalNoOfElements, bCalculateDate = false) => async (dispatch, getState) => {

    //dispatch(searchFuturesFailure({ data: [], count: 0 }));
    dispatch(updateIsLoading(true));
    const { data: arrSearchFutScrips = [] } = deepClone(getState().globalSearch.searchFutScrips);
    const objResponse = await _getSearchScripsFutures(sSearchText, mktAllowed, pageNo, totalNoOfElements, bCalculateDate);//ManasaB : 30/11/2023 : BT-115296 Calculator Bug Fixing 
    if (objResponse.status) {
        if (objResponse?.data?.arrSearchData && objResponse?.data?.arrSearchData.length > 0) {
            dispatch(searchFuturesSuccess({ data: [...arrSearchFutScrips, ...objResponse?.data?.arrSearchData], count: objResponse?.data?.objFUTScripResp.data.result.hits.total.value }));
            dispatch(updateIsLoading(false));
        } else {
            //BT-107433 : Calculator : ManasaB : 08-03-2024 : SAT issues - Start
            if (arrSearchFutScrips.length > 0) {
                dispatch(searchFuturesSuccess({ data: [...arrSearchFutScrips], count: arrSearchFutScrips.length }));
            }
            else {
                dispatch(searchFuturesFailure({ data: [], count: 0 }));
                dispatch(updateIsLoading(false));
            }
            //BT-107433 : Calculator : ManasaB : 08-03-2024 : SAT issues - End
        }
        return Promise?.resolve(objResponse?.data?.objFUTScripResp);//BT-114263 : Removing "All" tab and Adding count in search tabs : ManasaB : 24/07/2023 
    }
    else {
        dispatch(searchFuturesFailure({ data: [], count: 0 }));
        dispatch(updateIsLoading(false));
    }

};

export const searchFuturesSuccess = (payload) => {
    return { type: SCRIP_SEARCH.GET_SEARCH_FUT_SCRIPS_SUCCESS, payload };
};

export const searchFuturesFailure = (payload) => {
    return { type: SCRIP_SEARCH.GET_SEARCH_FUT_SCRIPS_FAILURE, payload };
};





export const getSearchScripsOptions = (sSearchText, mktAllowed, nPageNo, nTotalNoOfElements, isDefaultAllTab, bCalculateDate = false) => async (dispatch, getState) => {

    // dispatch(searchOptionsFailure({ data: [], count: 0 }));
    // if (isDefaultAllTab) { //ManasaB : 23-03-2024 : Calculator Bug Fixing 
    dispatch(updateIsLoading(true));
    const { data: arrSearchOptScrips = [] } = deepClone(getState().globalSearch.searchOptScrips);
    const objResponse = await _getSearchScripsOptions(sSearchText, mktAllowed, nPageNo, nTotalNoOfElements, bCalculateDate);//ManasaB : 30/11/2023 : BT-115296 Calculator Bug Fixing 
    if (objResponse.status) {
        if (objResponse?.data?.arrSearchData && objResponse?.data?.arrSearchData.length > 0) {
            dispatch(searchOptionsSuccess({ data: [...arrSearchOptScrips, ...objResponse?.data?.arrSearchData], count: objResponse?.data?.objOPTScripResp?.result?.hits?.total?.value }));//Hiral Mam suggested options tab length should be total no of expiries : ManasaB : 22/08/2023
            dispatch(updateIsLoading(false));
        } else {
            dispatch(searchOptionsFailure({ data: [], count: 0 }));
            dispatch(updateIsLoading(false));
        }
        //ManasaB : 30/11/2023 : BT-115296 Calculator Bug Fixing - Start
        if (objResponse?.data?.expiryDates?.length > 0) {
            dispatch(saveDistinctDates(objResponse?.data?.expiryDates));
        }
        //ManasaB : 30/11/2023 : BT-115296 Calculator Bug Fixing - End
        return Promise?.resolve(objResponse?.data?.objOPTScripResp);//BT-114263 : Removing "All" tab and Adding count in search tabs : ManasaB : 24/07/2023 
    }
    else {
        dispatch(searchOptionsFailure({ data: [], count: 0 }));
        dispatch(updateIsLoading(false));
    }
    // }
};

export const searchOptionsSuccess = (payload) => {
    return { type: SCRIP_SEARCH.GET_SEARCH_OPT_SCRIPS_SUCCESS, payload };
};

export const searchOptionsFailure = (payload) => {
    return { type: SCRIP_SEARCH.GET_SEARCH_OPT_SCRIPS_FAILURE, payload };
};
export const getTotalPages = () => async (dispatch, getState) => {
    const objDynamicMenu = deepClone(getState().appInfo.dynamicMenus);
    if (objDynamicMenu["mainMenu"]?.items && objDynamicMenu["hamburgerMenu"]?.items) {
        let arrMainMenu = objDynamicMenu["mainMenu"]?.items;
        let arrHambergerMenu = objDynamicMenu["hamburgerMenu"]?.items;
        var arrDynamicMenu = [...arrMainMenu, ...arrHambergerMenu];
    } else {
        arrDynamicMenu = [];
    }
    dispatch(updateTotalpages(arrDynamicMenu));
};
export const updateTotalpages = (payload) => {
    return { type: SCRIP_SEARCH.UPDATE_TOTAL_PAGES, payload };
};
export const getSearchPages = (sSearchText) => async (dispatch, getState) => {

    if (sSearchText) {
        const arrAllPages = deepClone(getState().globalSearch.arrTotalPages);
        const objResp = await _getSearchPages(sSearchText, arrAllPages);
        if (objResp.status) {
            if (objResp?.data?.arrSearchedPages && objResp?.data?.arrSearchedPages?.length > 0) {
                dispatch(updateSearchPages({ data: objResp?.data?.arrSearchedPages, count: objResp?.data?.arrSearchedPages.length }));
            } else {
                dispatch(updateSearchPages({ data: [], count: 0 }));
            }
        }
        else {
            dispatch(updateSearchPages({ data: [], count: 0 }));
        }
        if (objResp.data.arrSearchedPages.length > 0)
            dispatch(updateSearchScripDataStatusSuccess({ status: true, strNoDataMessage: '' }));
    } else {
        dispatch(updateSearchPages([]));
    }


};

export const updateSearchPages = (payload) => {
    return { type: SCRIP_SEARCH.UPDATE_SEARCH_PAGES, payload };
};
//As per PR comments added to redux state : Manasa B : 28/08/2023 - Start
export const getFilteredRecommendationScrips = (sSearchText, arrRecommendations) => async (dispatch) => {
    const objResponse = _getFilteredRecommendationScrips(sSearchText, arrRecommendations);
    if (objResponse.status) {
        dispatch(updateSearchRecommendationsSuccess(objResponse?.data?.arrReScrips));
    }
    else {
        dispatch(updateSearchRecommendationsFailure([]));
    }

};
export const getFilteredAlertScrips = (sSearchText, arrAlerts) => async (dispatch) => {
    const objResponse = _getFilteredAlertScrips(sSearchText, arrAlerts);
    if (objResponse.status) {
        dispatch(updateSearchAlertsSuccess(objResponse?.data?.arrAlertScrips));
    }
    else {
        dispatch(updateSearchAlertsFailure([]));
    }
};
export const getFilteredEvents = (sSearchText, arrEvents) => async (dispatch) => {
    const objResponse = _getFilteredEventScrips(sSearchText, arrEvents);
    if (objResponse.status) {
        dispatch(updateSearchEventsSuccess(objResponse?.data?.arrEventScrips));
    }
    else {
        dispatch(updateSearchEventsFailure([]));
    }
};
export const getFilteredIPO = (sSearchText, arrIPO) => async (dispatch) => {
    const objResponse = _getFilteredIPOScrips(sSearchText, arrIPO);
    if (objResponse.status) {
        dispatch(updateSearchIPOSuccess(objResponse?.data?.arrIPOScrips));
    }
    else {
        dispatch(updateSearchIPOFailure([]));
    }
};
export const getFilteredNews = (sSearchText, arrNews) => async (dispatch) => {
    const objResponse = _getFilteredNewsScrips(sSearchText, arrNews);
    if (objResponse.status) {
        dispatch(updateSearchNewsSuccess(objResponse?.data?.arrNewsScrips));
    }
    else {
        dispatch(updateSearchNewsFailure([]));
    }
};
export const updateSearchRecommendationsSuccess = (payload) => {
    return { type: SCRIP_SEARCH.GET_SEARCH_RECOMMENDATION_SCRIPS_SUCCESS, payload };
};
export const updateSearchRecommendationsFailure = (payload) => {
    return { type: SCRIP_SEARCH.GET_SEARCH_RECOMMENDATION_SCRIPS_FAILURE, payload };
};
export const updateSearchAlertsSuccess = (payload) => {
    return { type: SCRIP_SEARCH.GET_SEARCH_ALERT_SCRIPS_SUCCESS, payload };
};
export const updateSearchAlertsFailure = (payload) => {
    return { type: SCRIP_SEARCH.GET_SEARCH_ALERT_SCRIPS_FAILURE, payload };
};
export const updateSearchEventsSuccess = (payload) => {
    return { type: SCRIP_SEARCH.GET_SEARCH_EVENT_SCRIPS_SUCCESS, payload };
};
export const updateSearchEventsFailure = (payload) => {
    return { type: SCRIP_SEARCH.GET_SEARCH_EVENT_SCRIPS_FAILURE, payload };
};
export const updateSearchIPOSuccess = (payload) => {
    return { type: SCRIP_SEARCH.GET_SEARCH_IPO_SCRIPS_SUCCESS, payload };
};
export const updateSearchIPOFailure = (payload) => {
    return { type: SCRIP_SEARCH.GET_SEARCH_IPO_SCRIPS_FAILURE, payload };
};
export const updateSearchNewsSuccess = (payload) => {
    return { type: SCRIP_SEARCH.GET_SEARCH_NEWS_SCRIPS_SUCCESS, payload };
};
export const updateSearchNewsFailure = (payload) => {
    return { type: SCRIP_SEARCH.GET_SEARCH_NEWS_SCRIPS_FAILURE, payload };
};
export const resetSearchData = () => async (dispatch) => {
    dispatch(searchSuccess({ data: [], count: 0 }));
    dispatch(searchEquityFailure({ data: [], count: 0 }));
    dispatch(searchFuturesFailure({ data: [], count: 0 }));
    dispatch(searchOptionsFailure({ data: [], count: 0 }));
    dispatch(updateSearchRecommendationsFailure([]));
    dispatch(updateSearchAlertsFailure([]));
    dispatch(updateSearchEventsFailure([]));
    dispatch(updateSearchIPOFailure([]));
    dispatch(updateSearchNewsFailure([]));
    //As per PR comments added to redux state : Manasa B : 28/08/2023 - End
    dispatch(updateSearchPages([]));
};

export const setArrRecentlySearchScrips = (payload) => {
    return { type: SCRIP_SEARCH.RECENT_SEARCH_SCRIPS, payload: payload };
};

export const setArrTrending = (payload) => {
    return { type: SCRIP_SEARCH.TRENDING_SEARCH_SCRIPS, payload: payload };
};

// BT-118877 : Functional Implementation - Global Search : Vinit R : 09/10/2023 - Start 
export const setArrRecentlySearchMFScrips = (payload) => {
    return { type: SCRIP_SEARCH.RECENT_SEARCH_MF_SCRIPS, payload: payload };
};
// BT-118877 : Functional Implementation - Global Search : Vinit R : 09/10/2023 - End

export const setArrScripToBeAdded = (payload) => {
    return { type: SET_ARR_SCRIPS_TO_BE_ADDED, payload: payload };
};
export const updateGlobalAddScripWL = (payload) => {
    return { type: SCRIP_SEARCH.UPDATE_GLOBAL_ADDSCRIP_WATCHLIST, payload: payload };
};